import {FC} from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../../hooks/useAuth'

const RootRoute: FC = () => {
  const {isAuthenticated} = useAuth()

  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace/>
}

export default RootRoute
